
export const FETCH_LOADING = 'FETCH_LOADING'
export const ORIGIN = 'ORIGIN'
export const HASVALIDATE = 'HASVALIDATE'
export const PAGETYPE = 'PAGETYPE'
export const KEEPALIVE = 'KEEPALIVE'


// WEBPACK FOOTER //
// ./src/store/mutations-type.js